import IconButton from '@mui/material/IconButton';
import styled, { css } from 'styled-components';
import { Theme } from '../Theme'
export const StyledIconButton = styled(IconButton)`
    ${props => (props.selected) ? css`color: ${Theme.colors.primary} !important;` : ''}
    ${props => (props?.size === 'small') ? css`
        svg {
            width: 0.75em;
            height: 0.75em;
        }
    ` : ''}
`;